import { createStyles } from 'core/utilities/theme';
import { VISUALISATIONS_Z_INDEX } from 'sequenceAnalyser/components/Sequences/SequencesStyling/SequencesStyling.style';

export default createStyles({
  root: {
    position: 'fixed',
    zIndex: VISUALISATIONS_Z_INDEX,
  },
});
